<template>
    <div id="header" :class="{'search-opened': isSearchOpened, 'menu-opened': isMenuOpened}">
        <div class="container-fluid">
            <div id="header-container">
                <router-link :to="{ name: 'Home' }" class="header-logo d-none d-lg-block"></router-link> <!-- /#class-logo -->
                <div class="d-lg-none logo-container" ref="mobileLogo">
                  <router-link :to="{ name: 'Home' }" class="header-logo"></router-link> <!-- /#class-logo -->
                </div>

                <div id="main-navigation">
                    <a href="#" id="hamburger" :class="['d-lg-none', isMenuOpened ? 'opened' : '']" @click="openMenu" ref="hamburger">
                      <span></span>
                      <span></span>
                      <span></span>
                    </a>
                    <div id="mobile-nav" class="d-lg-none" ref="mobileNavigation">
                      <div class="mobile-nav-container">
                        <ul class="nav flex-column" v-if="isMenuLoaded">
                          <li :class="{'nav-item': true, 'has-child': menu.child_items}" v-for="(menu, key) in menus" :key="key" ref="menuMobileElements">
                            <a :href="menu.url" class="nav-link text-uppercase" v-if="!menu.route_name">{{ menu.title }}</a>
                            <router-link :to="{ name: menu.route_name ? menu.route_name : 'Page', params: { slug: menu.slug ? menu.slug : menu.post_name } }" :target="menu.target" class="nav-link text-uppercase" v-if="menu.route_name" @click.native="closeMenu">{{ menu.title }}</router-link>
                            <a href="#" :class="{'caret': true, 'opened': menuOpenedID === menu.ID}" v-if="menu.child_items" @click="setMenuId($event, menu.ID)">
                              <span class="caret-content"></span>
                            </a>
                            <transition name="slide">
                              <div v-if="menu.child_items && menuOpenedID === menu.ID">
                                <ul class="nav flex-column subnav">
                                  <li class="nav-item" v-for="submenu in menu.child_items" :key="submenu.id">
                                    <a :href="submenu.url" class="nav-link text-uppercase" v-if="!submenu.route_name" @click.native="closeMenu">{{ submenu.title }}</a>
                                    <router-link :to="{ name: submenu.route_name, params: { category: menu.post_name, slug: submenu.slug } }" :target="submenu.target" class="nav-link text-uppercase" v-if="submenu.route_name" @click.native="closeMenu">{{ submenu.title }}</router-link>
                                  </li>
                                </ul>
                              </div>
                            </transition>
                          </li>
                        </ul>
                        <div id="main-footer-nav" ref="mainFooterNav">
                          <div class="col">
                            <!-- Social -->
                            <ul class="nav" v-if="isOptionsContentLoaded">
                                <li class="nav-item" v-for="(social, index) in socials" :key="index">
                                  <a :href="social.url" :class="['nav-icon', social.social_network]" target="_blank">{{ social.social_network }}</a>
                                </li>
                            </ul>
                            <!-- /.nav Social -->
                          </div>
                            <div class="col">
                              <ul class="language-switcher d-flex m-0 justify-content-end align-items-center" v-if="isLanguagesLoaded">
                                <li v-for="lang in languages" :key="lang.ID"><a :href="$router.resolve({ params: { lang: lang.slug } }).href" :class="[currentLang === lang.slug ? 'active' : '', 'text-uppercase']">{{ lang.slug }}</a></li>
                              </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /#mobile-nav.d-lg-none -->

                    <ul class="nav d-none d-lg-flex flex-nowrap" ref="mainNavigation">
                        <li class="nav-item hide" v-for="(menu, key) in menus" :key="key" ref="menuElements">
                            <a :href="menu.url" class="nav-link text-uppercase" v-if="!menu.route_name">{{ menu.title }}</a>
                            <router-link :to="{ name: menu.route_name ? menu.route_name : 'Page', params: { slug: menu.slug ? menu.slug : menu.post_name } }" :target="menu.target" class="nav-link text-uppercase" v-if="menu.route_name">{{ menu.title }}</router-link>

                            <div class="sub-nav" v-if="menu.child_items">
                                <div class="container">
                                    <div class="nav">
                                        <li class="nav-item" v-for="submenu in menu.child_items" :key="submenu.id">
                                            <a :href="submenu.url" class="nav-link text-uppercase" v-if="!submenu.route_name" @mouseover="getProducts(submenu)">{{ submenu.title }}</a>
                                            <router-link :to="{ name: submenu.route_name, params: { category: menu.post_name, slug: submenu.slug } }" :target="submenu.target" class="nav-link text-uppercase" v-if="submenu.route_name" @mouseover.native="getProducts(submenu)">{{ submenu.title }}</router-link>
                                            <div class="sub-nav sub-nav-product" v-if="submenu.route_name === 'PageCategory'">
                                              <div class="container">
                                                <ul class="nav placeholder" v-if="!loaded[submenu.slug]">
                                                  <li class="nav-item" v-for="i in 5" :key="i">
                                                    <a href="" class="nav-link">
                                                      <div class="menu-product">
                                                        <div class="product-image bg">
                                                        </div>
                                                        <div class="paragraph mt-4"></div>
                                                      </div>
                                                    </a>
                                                  </li>
                                                </ul>
                                                <swiper :options="swiperOption" class="menuproduct-container">
                                                  <swiper-slide v-for="product in products[submenu.slug]" :key="product.id">
                                                    <router-link :to="{ name: 'product', params: { slug: product.slug } }" class="nav-link">
                                                      <div class="menu-product">
                                                        <div class="product-image">
                                                          <img :src="product._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url" alt="">
                                                        </div>
                                                        <div class="product-name text-uppercase text-center mt-4" v-html="product.title.rendered"></div>
                                                      </div>
                                                    </router-link>
                                                  </swiper-slide>
                                                  <div class="swiper-button-prev small" slot="button-prev"></div>
                                                  <div class="swiper-button-next small" slot="button-next"></div>
                                                </swiper>
                                              </div>
                                            </div>
                                        </li>
                                    </div>
                                </div>
                            </div>
                            <!-- /.sub-nav -->
                        </li>
                    </ul>
                    <!-- /.nav -->

                    <!-- Search -->
                    <div id="search-container" ref="searchContainer">
                      <form action="/search" v-on:submit="searchSubmit($event)">
                        <div class="d-flex align-items-center">
                          <div class="search-icon">
                            <div class="magnifier-circle"></div>
                          </div>
                          <div class="search-wrapper">
                            <input type="search" ref="searchInput" :placeholder="$t('message.searchplaceholder')" v-model="form.search">
                          </div>
                        </div>
                      </form>
                    </div>
                    <button class="search" @click="searchOpen" v-if="isMenuLoaded" ref="searchIcon">
                      <div class="magnifier-circle"></div>
                    </button>
                </div>
                <!-- /#main-navigation -->

                <div id="header-utilities" class="d-none d-lg-flex">
                    <!-- Social -->
                    <ul class="nav" v-if="isOptionsContentLoaded">
                        <li class="nav-item" v-for="(social, index) in socials" :key="index">
                          <a :href="social.url" :class="['nav-icon', social.social_network]" target="_blank">{{ social.social_network }}</a>
                        </li>
                    </ul>
                    <!-- /.nav Social -->

                    <ul class="language-switcher d-flex" v-if="isLanguagesLoaded">
                        <li v-for="lang in languages" :key="lang.ID"><a :href="$router.resolve({ params: { lang: lang.slug } }).href" :class="[currentLang === lang.slug ? 'active' : '', 'text-uppercase']">{{ lang.slug }}</a></li>
                    </ul>
                    <!-- /#language-switcher -->
                </div>
                <!-- /#header-utilities -->
            </div>
            <!-- /#header-container -->
        </div>
        <!-- /.container -->
    </div>
  <!-- /#header -->
</template>

<script>
import axios from 'axios'
import { TimelineLite, Power0 } from 'gsap'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '@/assets/sass/header.sass'
export default {
  name: 'HeaderComponent',
  props: [
    'socials', 'isOptionsContentLoaded'
  ],
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      isMenuLoaded: false,
      menus: [],
      menuTween: new TimelineLite({ paused: true }),
      searchTween: new TimelineLite(),
      hamburgerTween: new TimelineLite(),
      logoTween: new TimelineLite(),
      mobileNavTween: new TimelineLite(),
      isSearchOpened: false,
      isShowSearchPlaceholder: false,
      products: {},
      loaded: {},
      form: {
        search: this.$route.params.query
      },
      isMenuOpened: false,
      menuOpenedID: '',
      targetElement: null,
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        loop: false,
        loopFillGroupWithBlank: false,
        mousewheel: true,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      languages: [],
      isLanguagesLoaded: false,
      currentLang: this.$route.params.lang
    }
  },
  mounted () {
    this.getMenus()
    this.getLangs()
    // Hide search form by default
    this.searchTween.set(this.$refs.searchContainer, { autoAlpha: 0, x: '10%', scale: 0.9 })
    this.targetElement = document.querySelector('#mobile-nav')
  },
  methods: {
    getMenus () {
      const $vm = this
      const lang = this.$route.params.lang
      axios.get(`${this.api_path}wp-json/menus/v1/menus/main-navigation`, {
        params: {
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.menus = res.data.items
            $vm.isMenuLoaded = true
            setTimeout(() => {
              $vm.animateMenu()
              // Hide mobile menus
              $vm.mobileNavTween.set($vm.$refs.menuMobileElements, { autoAlpha: 0, y: '-10%' })
                .set($vm.$refs.mainFooterNav, { autoAlpha: 0 })
            }, 100)
          }
        })
    },
    animateMenu () {
      const { menuElements } = this.$refs
      this.menuTween
        .staggerTo(menuElements, 0.3, { opacity: 1, visibility: 'visible', ease: Power0.easeOut }, 0.04)
        .play()
    },
    searchOpen () {
      this.isSearchOpened = !this.isSearchOpened
      const { menuElements, searchContainer, hamburger, mobileLogo } = this.$refs
      if (this.isSearchOpened) {
        this.menuTween
          .staggerTo(menuElements, 0.18, { opacity: 0, visibility: 'hidden', ease: Power0.easeOut }, -0.04)
          .play()
        // Open search form
        this.searchTween
          .to(searchContainer, 0.18, { delay: 0.3, autoAlpha: 1, x: '0%', scale: 1, ease: Power0.easeIn, onComplete: this.setSearchInput })
        // Hamburger
        this.hamburgerTween
          .to(hamburger, 0.18, { autoAlpha: 0, visibility: 'hidden', x: '-100%', ease: Power0.easeOut })
        // Mobile Logo
        this.hamburgerTween
          .to(mobileLogo, 0.18, { autoAlpha: 0, visibility: 'hidden', y: '-50%', ease: Power0.easeOut })
      } else {
        this.menuTween
          .staggerTo(menuElements, 0.18, { opacity: 1, visibility: 'visible', ease: Power0.easeOut }, 0.04)
          .play()
        // Close search form
        this.searchTween
          .to(searchContainer, 0.18, { autoAlpha: 0, x: '10%', scale: 0.9, ease: Power0.easeIn })
        // Hamburger
        this.hamburgerTween
          .to(hamburger, 0.18, { autoAlpha: 1, visibility: 'visible', x: '0%', ease: Power0.easeOut })
        // Mobile Logo
        this.hamburgerTween
          .to(mobileLogo, 0.18, { autoAlpha: 1, visibility: 'visible', y: '0%', ease: Power0.easeOut })
      }
    },
    getProducts (menu) {
      if (menu.route_name !== 'PageCategory') return
      const cat = menu.object_id
      const slug = menu.slug
      const $vm = this
      if (!$vm.products[slug]) {
        $vm.loaded[slug] = false
        $vm.$forceUpdate()
        const params = {
          categories: parseInt(cat),
          _embed: true,
          wpse_custom_order: 'menu_order',
          order: 'asc'
        }
        axios.get(`${this.api_path}wp-json/wp/v2/product`, {
          params
        })
          .then(res => {
            if (res.data) {
              $vm.products[slug] = res.data
              $vm.loaded[slug] = true
              $vm.$forceUpdate()
            }
          })
      }
    },
    setSearchInput () {
      const { searchInput } = this.$refs
      searchInput.focus()
    },
    searchSubmit (e) {
      e.preventDefault()
      this.$router.push({ name: 'Search', params: { query: this.form.search } })
    },
    openMenu (e) {
      e.preventDefault()
      const { searchIcon, menuMobileElements, mainFooterNav } = this.$refs
      this.isMenuOpened = !this.isMenuOpened
      if (this.isMenuOpened) {
        this.searchTween
          .to(searchIcon, 0.18, { autoAlpha: 0, x: '50%', ease: Power0.easeOut })
        this.mobileNavTween
          .staggerTo(menuMobileElements, 0.18, { autoAlpha: 1, y: '0%', delay: 0.2, ease: Power0.easeOut }, 0.04)
          .to(mainFooterNav, 0.18, { autoAlpha: 1, delay: 0.8, ease: Power0.easeOut }, 0.04)
        // Disable Scoll
        disableBodyScroll(this.targetElement)
      } else {
        this.searchTween
          .to(searchIcon, 0.18, { autoAlpha: 1, x: '0%', ease: Power0.easeOut })
        this.mobileNavTween
          .staggerTo(menuMobileElements, 0.18, { autoAlpha: 0, y: '-10%', ease: Power0.easeOut }, -0.04)
          .to(mainFooterNav, 0.18, { autoAlpha: 0, ease: Power0.easeOut }, 0.04)
        // Enable Scroll
        enableBodyScroll(this.targetElement)
      }
    },
    closeMenu () {
      const { searchIcon, menuMobileElements } = this.$refs
      this.isMenuOpened = false
      this.searchTween
        .to(searchIcon, 0.18, { autoAlpha: 1, x: '0%', ease: Power0.easeOut })
      this.mobileNavTween
        .staggerTo(menuMobileElements, 0.18, { autoAlpha: 0, y: '-10%', ease: Power0.easeOut }, -0.04)

      // Clear Scroll
      clearAllBodyScrollLocks()
    },
    setMenuId (e, menu) {
      e.preventDefault()
      if (this.menuOpenedID === menu) {
        this.menuOpenedID = ''
      } else {
        this.menuOpenedID = menu
      }
    },
    getLangs () {
      const vm = this
      axios.get(`${this.api_path}wp-json/pll/v1/languages`)
        .then(res => {
          if (res.data) {
            vm.languages = res.data
            vm.isLanguagesLoaded = true
            vm.currentLang = vm.$route.params.lang
          }
        })
    }
  }
}
</script>
